import * as React from 'react';

const LogoBandsintownColorSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 72 72" {...props}>
        <path fill="#00b4b3" d="M0 0h72v72H0z" />
        <path fill="#fff" d="M63 64V39H23v11h28v2H21V8H9v56h54z" />
        <path fill="#fff" d="M23 23h12v14H23zM37 23h12v14H37zM51 8h12v29H51z" />
    </svg>
);

LogoBandsintownColorSvg.displayName = 'LogoBandsintownColorSvg';
export default LogoBandsintownColorSvg;
